import axios from "axios";

const httpClient = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 60000,
  headers: {
    "Referrer-Policy": "no-referrer-when-downgrade",
    "Content-Type": "application/json",
    "X-Permitted-Cross-Domain-Policies": "none",
    "Accept-Ranges": 0,
    "X-Content-Type-Options": "nosniff",
    "X-Frame-Options": "Deny",
    "X-Xss-Protection": 0,
  },
});
export default httpClient;
